{
  "issuer": "https://idp-dev.unicloudgroup.com.vn/realms/realm_uat_hrm",
  "clientId": "web_uni_hrm_uat",
  "webId": null,
  "redirectUri": null,
  "logoutUrl": null,
  "responseType": "code",
  "scope": "openid profile",
  "requireHttps": false,
  "showDebugInformation": true,
  "disableAtHashCheck": true,
 "apiServer": "https://dev.api.unicloudgroup.com.vn",
  "apShomeServer": "https://dev.api.apiresident.unicloudgroup.com.vn",
  "apiCoreServer": "https://dev.api.core.unicloudgroup.com.vn",
  "apiHrmConfig": "https://uat.api.hrmconfig.unicloudgroup.com.vn",
  "apiHrmServer": "https://uat.api.hrm.unicloudgroup.com.vn",
  "pathUpload": "bizzone-web",
  "socketServer": "wss://localhost:6999",
  "apSocketChatServer": "https://chat.sunshineapp.co/api",
  "cloudFunction": "https://asia-northeast1-sunshine-app-production.cloudfunctions.net",
  "firebase": null
}